module.exports = __webpack_public_path__ + "fonts/Inter-800-vietnamese57.74fe938.woff2";